import { render, staticRenderFns } from "./incident-category.vue?vue&type=template&id=200df4e1&scoped=true"
import script from "./incident-category.vue?vue&type=script&lang=js"
export * from "./incident-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200df4e1",
  null
  
)

export default component.exports